"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRequestLocationEnum = void 0;
var HttpRequestLocationEnum;
(function (HttpRequestLocationEnum) {
    HttpRequestLocationEnum["HEADER"] = "HEADER";
    HttpRequestLocationEnum["QUERY_PARAM"] = "QUERY_PARAM";
})(HttpRequestLocationEnum = exports.HttpRequestLocationEnum || (exports.HttpRequestLocationEnum = {}));
//# sourceMappingURL=httpRequestLocationEnum.js.map